import { getSupabase } from "./supabase";

async function authHeaders(): Promise<HeadersInit> {
  try {
    const { data } = await getSupabase().auth.getSession();
    const token = data.session?.access_token;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

async function parseError(res: Response): Promise<string> {
  try {
    const data = (await res.json()) as { error?: string };
    if (data?.error) return data.error;
  } catch {
    /* ignore */
  }
  return `Erro ${res.status}`;
}

export type RepairReceivedPayload = {
  nome: string;
  telefone: string;
  tipo_equipamento: string;
  categoria_problema: string;
  urgencia: "normal" | "urgente";
  disponibilidade_data?: string | null;
  disponibilidade_periodo?: string | null;
};

export async function notifyRepairReceived(payload: RepairReceivedPayload): Promise<void> {
  const res = await fetch("/api/whatsapp/repair-received", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    console.warn("[whatsapp] pedido recebido:", await parseError(res));
  }
}

export async function notifyRepairScheduled(payload: {
  nome: string;
  telefone: string;
  tipo_equipamento: string;
  scheduled_date: string | null;
  scheduled_time: string | null;
}): Promise<boolean> {
  const res = await fetch("/api/whatsapp/repair-scheduled", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(await authHeaders()),
    },
    body: JSON.stringify(payload),
  });
  return res.ok;
}

export async function fetchWhatsappStatus(): Promise<{
  status: string;
  connected: boolean;
  session: string;
}> {
  const res = await fetch("/api/whatsapp/status", { headers: await authHeaders() });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json();
}

export async function fetchWhatsappQr(): Promise<{ dataUrl: string }> {
  const res = await fetch("/api/whatsapp/qr", { headers: await authHeaders() });
  if (!res.ok) throw new Error(await parseError(res));
  return res.json();
}
